import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import "./dashboard.css";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import { Card } from "@mui/material";
import "./dashboard.css";
import request, { gql } from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { fromGlobalId } from "../../lib/decoded/rawPk";
import DashoardCard from "./DashoardCard";
import ApexChart from "./apexChart/ApexBarChart";
import ApexPieChart from "./apexChart/ApexPieChart";

const Dashboard = () => {
  const { currentUser } = useAuth();

  return (
    <DashboardLayout>
      {/* <Card> */}
        <div className="dashboard-mainbox">
          {/* <h2 className="dashboard-title">Welcome {currentUser?.username}</h2> */}
          <div>
            <DashoardCard />
          </div>
        </div>
      {/* </Card> */}
    </DashboardLayout>
  );
};

export default Dashboard;
